import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {getDealerPocDetails, updateDealerPocDetails } from "../../../service/Dealer/action";
import AddDealerPoc from "./AddDealerPoc";

const mapStateToProps = (state) => ({
    updatePocDetails:state.Dealer.updatePocDetails,
    getPocDetails:state.Dealer.getPocDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateDealerPocDetails,
            getDealerPocDetails,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddDealerPoc);
